// React
import React, { Component } from 'react';
import BootstrapTable from 'react-bootstrap-table-next';
import classNames from 'classnames';

class ResultsTable extends Component {
  constructor(props) {
    super(props);

    this.headerFormatter = this.headerFormatter.bind(this);
    this.onMouseDown = this.onMouseDown.bind(this);
    this.onMouseMove = this.onMouseMove.bind(this);
    this.onMouseUp = this.onMouseUp.bind(this);

    this.tableRef = React.createRef();

    this.state = {
      drag: false,
      startX: 0,
      startY: 0
    };
  }

  componentDidMount() {
    if(typeof this.tableRef != 'undefined') {
      // Initialize mouse event listeners on the table container
      this.tableRef.current.addEventListener('mousedown', this.onMouseDown);
      this.tableRef.current.addEventListener('mousemove', this.onMouseMove);
      this.tableRef.current.addEventListener('mouseup', this.onMouseUp);

      //let tableHeaders = this.tableRef.current.getElementsByTagName('thead');
      //if(tableHeaders.length > 0) {
      //  let tableHeader = tableHeaders[0].cloneNode(true);
      //  let fixedTable = document.createElement('table');
      //  fixedTable.style.position = 'absolute';
      //  fixedTable.append(tableHeader);
      //
      //  this.tableRef.current.prepend(fixedTable);
      //}
    }
  }


  componentWillUnmount() {
    if(typeof this.tableRef != 'undefined') {
      // Remove all event listeners from the table container
      this.tableRef.current.removeEventListener('mousedown', this.onMouseDown);
      this.tableRef.current.removeEventListener('mousemove', this.onMouseMove);
      this.tableRef.current.removeEventListener('mouseup', this.onMouseUp);
    }
  }

  onMouseDown(e) {
    if(typeof this.tableRef != 'undefined') {
      // Set the drag state to true and update the start X and Y values
      this.setState({
        drag: true,
        startX: e.clientX + this.tableRef.current.scrollLeft,
        startY: e.clientY + this.tableRef.current.scrollTop
      });
    }
  }

  onMouseMove(e) {
    const { drag, startX, startY } = this.state;

    // If dragging...
    if(drag && typeof this.tableRef != 'undefined') {
      // Determine updated scroll Left and Top positions based off of the difference from the originals
      let diffX = (startX - (e.clientX + this.tableRef.current.scrollLeft));
      let diffY = (startY - (e.clientY + this.tableRef.current.scrollTop));
      this.tableRef.current.scrollLeft += diffX;
      this.tableRef.current.scrollTop += diffY;
    }
  }

  onMouseUp() {
    // Turn off the drag state
    this.setState({
      drag: false
    });
  }

  headerFormatter(column) {
    const { sortBy, sortOrder, updateSort } = this.props;

    let onClickFunc = () => {};
    if(column.defaultSortOrder) {
      let newSortOrder = (sortOrder === 'desc') ? 'asc' : 'desc';
      if(sortBy !== column.dataField) {
        newSortOrder = column.defaultSortOrder;
      }

      onClickFunc = () => updateSort(column.dataField, newSortOrder);
    }

    return (
      <div className="column-header d-flex align-items-end" onClick={onClickFunc}>
        <span>{ column.text }</span>
        { column.dataField === sortBy && sortOrder === 'desc' &&
          <span className="fas fa-arrow-down" />
        }
        { column.dataField === sortBy && sortOrder === 'asc' &&
          <span className="fas fa-arrow-up" />
        }
      </div>
    )
  }

  render() {
    const { columns, rows } = this.props;
    const { drag } = this.state;

    columns.forEach((column) => {
      column.headerFormatter = this.headerFormatter;
    });

    const tableClasses = classNames({
      'table-responsive': true,
      'hover-cursor-grab': true,
      'grabbing': drag
    });

    return (
      <div className={tableClasses} ref={this.tableRef}>
        <BootstrapTable
          keyField='_id'
          data={ rows }
          columns={ columns }
          striped
          hover
        />
      </div>
    )
  }
}

export default ResultsTable;
